module.exports = __webpack_public_path__ + "img/bvmed_footer.d9742b06.png";